import actionTypes from "./actionTypes";
import api from "./api";
export default {
    deleteSummaryReport: (summaryReportId) => ({
        type: actionTypes.DELETE_SUMMARY_REPORT,
        payload: {
            promise: () => api.deleteSummaryReport(summaryReportId)
        },
        scope: `${actionTypes.DELETE_SUMMARY_REPORT}_${summaryReportId}`,
        meta: {
            summaryReportId
        }
    })
};
